import styled from 'styled-components';
import { Button, ButtonProps } from 'antd';

export type PropsButtons = ButtonProps & {};

export default styled(Button)<PropsButtons>`
  border: 1px solid var(--border-color-base);
  border-radius: 4px;
  height: ${(props) => getHeight(props.size)};
  min-width: 160px;
  color: var(--border-color-base);
  font-weight: 600;

  > span {
    font-size: ${(props) => getFontSize(props.size)};
  }

  &.ant-btn-primary {
    background: linear-gradient(149.45deg, #3c82c0 0%, #1c4b8c 100%);
    color: var(--white);
    border: unset;
  }
  &:disabled {
    border: 1px solid #cccccc !important;
    color: #808080 !important;
    font-weight: 600;
  }
`;

function getHeight(size: ButtonProps['size']): string {
  switch (size) {
    case 'small':
      return '24px';
    default:
      return '40px';
  }
}

function getFontSize(size: ButtonProps['size']): string {
  switch (size) {
    case 'small':
      return '12px';
    default:
      return '14px';
  }
}
